import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filternotin',
    standalone: false
})
export class FilterNotInPipe implements PipeTransform {

  transform(items: any[], ignoreFields: any[]): any[] {
    return items.filter(item => ignoreFields.indexOf(item) === -1);
  }

}
